import React, { useEffect } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import SharedWalletCard from "pages/Gold/Shared/SharedWalletCards";
import { useDispatch, useSelector } from "react-redux";
import { fetchGoldOrders } from "store/actions";

export default function PurchaseHistory(props) {
  const { isDemo } = props;
  const { t } = useTranslation();
  const { loading, orders } = useSelector((state) => state.goldReducer.orders);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGoldOrders({
      isDemo,
    }));
  }, []);

  const columns = [
    {
      dataField: "createdAt",
      text: t("Order Date"),
      formatter: (val) => <span>{moment(val.createdAt).format("DD-MM-YYYY")}</span>,
    },
    {
      dataField: "type",
      text: t("Title"),
      formatter: (val) => (<>{val?.products?.title}</>),
    },
    {
      dataField: "currency",
      text: t("Currency Used"),
      formatter: (val) => (val.currency),
    },
    {
      dataField: "qty",
      text: t("Quantity"),
      formatter: (item) => item.quantity
    },
    {
      dataField: "amount",
      text: t("Amount"),
      formatter: (item) =>
        parseFloat(item?.amount?.$numberDecimal)?.toFixed(2) || parseFloat(item?.amount)?.toFixed(2) || "-",
    },
    {
      dataField: "delivery",
      text: t("Order Type"),
      formatter: (val) => (val?.type?.split("_").join(" ") || "-"),
    },
  ];
  return (
    <SharedWalletCard t={t} title="Purchase History" loading={loading} data={orders} columns={columns}  />
  );
}
